import React, { useMemo, useState } from "react";
import { Add24Regular, AddCircle24Regular, ArrowRight24Regular, Checkmark12Regular, Checkmark24Regular, CheckmarkCircle24Regular, ChevronRight24Regular, Delete24Regular, Dismiss24Regular, Document24Regular, Edit24Regular, Emoji24Regular, EmojiAngry24Regular, EmojiLaugh24Regular, EmojiMeh24Regular, EmojiSad24Regular, ErrorCircle24Regular, Globe24Regular, Heart24Filled, Heart24Regular, Home24Regular, Image24Regular, Info24Regular, Link24Regular, LinkDismiss24Regular, Location24Regular, Map24Regular, SignOut24Regular, Star24Filled, Star24Regular, Subtract24Regular, SubtractCircle24Regular, TextBulletListLtr24Regular, TextNumberListLtr24Regular, Warning24Regular, WeatherMoon24Regular, WeatherSunny24Regular, } from "@fluentui/react-icons";
import { useAdaptiveUi } from "../adaptive-ui/AdaptiveUi";
import "./Icon.scss";
// Note: Directional options are normalised, arrows should point right for consistency during rotations.
const icons = {
    _missing: (React.createElement("svg", { viewBox: "0 0 10 10" },
        React.createElement("g", { fill: "red" },
            React.createElement("rect", { width: 10, height: 10 })))),
    add: React.createElement(Add24Regular, null),
    addCircle: React.createElement(AddCircle24Regular, null),
    arrow: React.createElement(ArrowRight24Regular, null),
    checkmark: React.createElement(Checkmark24Regular, null),
    checkboxCheckmark: React.createElement(Checkmark12Regular, null),
    checkmarkCircle: React.createElement(CheckmarkCircle24Regular, null),
    chevron: React.createElement(ChevronRight24Regular, null),
    circleFilled: (React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor" },
        React.createElement("circle", { r: "7", cx: "12", cy: "12" }))),
    delete: React.createElement(Delete24Regular, null),
    dismiss: React.createElement(Dismiss24Regular, null),
    document: React.createElement(Document24Regular, null),
    edit: React.createElement(Edit24Regular, null),
    emoji: React.createElement(Emoji24Regular, null),
    emojiAngry: React.createElement(EmojiAngry24Regular, null),
    emojiLaugh: React.createElement(EmojiLaugh24Regular, null),
    emojiMeh: React.createElement(EmojiMeh24Regular, null),
    emojiSad: React.createElement(EmojiSad24Regular, null),
    errorCircle: React.createElement(ErrorCircle24Regular, null),
    globe: React.createElement(Globe24Regular, null),
    heart: React.createElement(Heart24Regular, null),
    heartFilled: React.createElement(Heart24Filled, null),
    home: React.createElement(Home24Regular, null),
    image: React.createElement(Image24Regular, null),
    info: React.createElement(Info24Regular, null),
    link: React.createElement(Link24Regular, null),
    linkDismiss: React.createElement(LinkDismiss24Regular, null),
    location: React.createElement(Location24Regular, null),
    map: React.createElement(Map24Regular, null),
    signOut: React.createElement(SignOut24Regular, null),
    star: React.createElement(Star24Regular, null),
    starFilled: React.createElement(Star24Filled, null),
    subtract: React.createElement(Subtract24Regular, null),
    subtractCircle: React.createElement(SubtractCircle24Regular, null),
    textBulletList: React.createElement(TextBulletListLtr24Regular, null),
    textNumberList: React.createElement(TextNumberListLtr24Regular, null),
    themeDark: React.createElement(WeatherMoon24Regular, null),
    themeLight: React.createElement(WeatherSunny24Regular, null),
    warning: React.createElement(Warning24Regular, null),
    blank: React.createElement("svg", { viewBox: "0 0 10 10" }),
};
/**
 * Render an SVG icon. The icon adapts to the surrounding font size and text
 * color. Styling the icon directly is only necessary when it should not
 * automatically match the text. Use the `color` CSS property on the icon to
 * change its color.
 */
const Icon = ({ name, rotate = 0, flip = false, title, className, }) => {
    var _a;
    const { icons: overrides } = (_a = useAdaptiveUi()) !== null && _a !== void 0 ? _a : {};
    const icon = useMemo(() => {
        const icon = overrides && Object.prototype.hasOwnProperty.call(overrides, name)
            ? overrides[name]
            : icons[name];
        if (!icon)
            console.warn("Missing icon in icon set:", name);
        return icon !== null && icon !== void 0 ? icon : icons._missing;
    }, [name, overrides]);
    return (React.createElement("span", { className: `aui-icon ${rotate ? "r" + rotate : ""} ${flip ? "flip" : ""} ${className !== null && className !== void 0 ? className : ""}`, title: title }, icon));
};
/**
 * Renders all available icons. Useful during development.
 */
export const IconList = () => {
    var _a;
    const { icons: overrides } = (_a = useAdaptiveUi()) !== null && _a !== void 0 ? _a : {};
    const names = new Set(Object.keys(icons));
    const [query, setQuery] = useState("");
    if (overrides) {
        Object.keys(overrides).forEach((key) => names.add(key));
    }
    return (React.createElement("div", { className: "aui-icon-list" },
        React.createElement("header", null,
            React.createElement("h2", null, "Icons"),
            React.createElement("input", { type: "search", value: query, onChange: (e) => setQuery(e.target.value), placeholder: "Search icon names" })),
        React.createElement("section", null, Array.from(names.values())
            .filter((name) => name !== "_missing" &&
            (!query || name.toLowerCase().includes(query)))
            .sort()
            .map((name) => (React.createElement("div", { key: name },
            React.createElement(Icon, { name: name }),
            " ",
            name))))));
};
export default Icon;
